<template>
    <el-dialog title="权限" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false" label-width="200px">
        <el-form size="small" :model="form">



                <el-form-item label="权限列表：" v-model="form.access_id">
                    <el-tree
                    :data="data"
                    show-checkbox
                    node-key="access_id"
                    :default-expand-all="true"
                    :default-checked-keys="select_menu"
                    :props="defaultProps"
                    @check="handleCheckChange"

                    ></el-tree>
                </el-form-item>
                
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
   import UroleApi from '@/api/urole.js';
    export default {
        components: {
   
        },
        data() {
            return {
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                loading: false,
                dialogVisible: false,
                form:{

                },
                data:[],
                      /*权限选中*/
           /*权限选中*/
           select_menu: [],
            /*权限树菜单重新自定义字段*/
            defaultProps: {
                children: 'children',
                label: 'name'
            },
  
            
            };
        },
        props: ['open_add','user_role_id'],
        created() {
            console.log(this.form)
            this.dialogVisible = this.open_add;
            this.getDetail();
        },
        methods: {
                    /*清除数据*/
            clearData(list, authlist) {
            let total = 0;
            let leng = list.length;
            for (let i = 0; i < leng; i++) {
                let item = list[i];
                if (item.children != null) {
                let flag = this.clearData(item.children, authlist);
                if (!flag) {
                    let _index = authlist.indexOf(item.access_id);
                    if (_index >= 0) {
                    authlist.splice(_index, 1);
                    }
                }
                }
                if (authlist.indexOf(item.access_id) != -1) {
                total++;
                }
            }
            if (total < leng) {
                return false;
            } else {
                return true;
            }
            },
                /*监听选中*/
            handleCheckChange(data, checked) {
            this.form.access_id = checked.checkedKeys.concat(checked.halfCheckedKeys);
            },

            getDetail() {
            let self = this;
            // 取到路由带过来的参数
            UroleApi.detail({user_role_id: self.user_role_id},true).then(data => {
                self.form = data.data.detail;
                    self.clearData(data.data.menu, data.data.select_menu);
                    self.select_menu = data.data.select_menu;
                    self.roleList = data.data.roleList;
                    self.data = data.data.menu;
                    if (self.form.parent_id == 0) {
                        self.form.parent_id = 0 + '';
                    }
                })
                .catch(error => {});
            },
            editUser(){
                let self = this;
                let form = self.form;
                form.user_role_id = self.user_role_id;

                self.loading = true;
                    UroleApi.editAuth(form, true)
                        .then(data => {
                        self.loading = false;
                        self.$message({
                            message: data.msg,
                            type: 'success'
                        });
                        self.dialogFormVisible("error")
                        })
                        .catch(error => {
                        self.loading = false;
                        });
            },
            /*关闭弹窗*/
            dialogFormVisible(e) {
                if (e) {
                    this.$emit('closeDialog', {
                        type: 'success',
                        openDialog: false
                    })
                } else {
                    this.$emit('closeDialog', {
                        type: 'error',
                        openDialog: false
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/plus/urole/index/part/auth.vue